import { CSSProperties, FC } from 'react'
import { Heading } from '@ui/Heading'
import BadSmile from '@images/BadSmile.svg'
import NormalSmile from '@images/NormalSmile.svg'
import GoodSmile from '@images/GoodSmile.svg'
import { Inline } from '@shared/layout/Inline'
import { FeedBackDescription, FeedBackIconContainer, ImageContainer } from './styles'

export const FeedBack: FC<{ style?: CSSProperties }> = ({ style }) => {
	return (
		<div style={{ paddingLeft: 20, paddingRight: 20, ...style }}>
			<Heading style={{ marginBottom: 16 }}>Как вы себя чувствуете?</Heading>

			<Inline justify={'center'} gap={20} align={'center'}>
				<FeedBackIconContainer>
					<div>
						<ImageContainer src={BadSmile} width={56} height={56} />
					</div>
					<FeedBackDescription>Устало</FeedBackDescription>
				</FeedBackIconContainer>
				<FeedBackIconContainer>
					<div>
						<ImageContainer src={NormalSmile} width={56} height={56} />
					</div>
					<FeedBackDescription>Отлично</FeedBackDescription>
				</FeedBackIconContainer>
				<FeedBackIconContainer>
					<ImageContainer src={GoodSmile} width={62} height={59} />
					<FeedBackDescription>Очень хорошо</FeedBackDescription>
				</FeedBackIconContainer>
			</Inline>
		</div>
	)
}
